// extracted by mini-css-extract-plugin
export var container = "lineItems-module--container--v7pqD";
export var lineImage = "lineItems-module--lineImage--RqcK4";
export var lineImageSafari = "lineItems-module--lineImageSafari--13iRI";
export var productImgContainer = "lineItems-module--productImgContainer--iBrIE";
export var qtyContainer = "lineItems-module--qtyContainer--F0M7L";